/* Progressive enhancement only. Nothing is hidden before this runs. */
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    var progress = document.querySelector('[data-wm-progress]');
    if (progress && !reduce.matches) {
      var onScroll = function () {
        var height = document.documentElement.scrollHeight - window.innerHeight;
        var ratio = height > 0 ? window.scrollY / height : 0;
        progress.style.transform = 'scaleX(' + ratio + ')';
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    var menu = document.querySelector('[data-wm-menu]');
    if (menu) {
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && menu.open) {
          menu.open = false;
          menu.querySelector('summary').focus();
        }
      });
    }

    var top = document.createElement('button');
    top.className = 'wm-back-top';
    top.type = 'button';
    top.setAttribute('aria-label', 'Back to top');
    top.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 19V5M6 11l6-6 6 6"/></svg>';
    top.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce.matches ? 'auto' : 'smooth' });
      var wordmark = document.querySelector('.wm-wordmark');
      if (wordmark) { wordmark.focus({ preventScroll: true }); }
    });
    document.body.appendChild(top);
    window.addEventListener('scroll', function () {
      top.setAttribute('data-visible', window.scrollY > window.innerHeight ? 'true' : 'false');
    }, { passive: true });
  })();

/* Mega menu: hover on fine pointers, click and keyboard everywhere. Also marks the current page in the nav. */
(function () {
  var megas = Array.prototype.slice.call(document.querySelectorAll('[data-wm-mega]'));
  var path = location.pathname.replace(/\/$/, '') || '/';
  document.querySelectorAll('.wm-nav > a, .wm-mobile-menu a').forEach(function (a) {
    var p = a.getAttribute('href');
    if (p && p.replace(/\/$/, '') === path) { a.setAttribute('aria-current', 'page'); }
  });
  if (!megas.length) { return; }
  if (/^\/pages\/(work|case-)/.test(path)) {
    megas.forEach(function (m) { m.querySelector('.wm-mega-trigger').setAttribute('aria-current', 'page'); });
  }
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var wide = window.matchMedia('(min-width: 991px)');
  var timer = 0;
  function setOpen(m, open) {
    m.classList.toggle('is-open', open);
    m.querySelector('.wm-mega-trigger').setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeAll(except) { megas.forEach(function (m) { if (m !== except) { setOpen(m, false); } }); }
  function open(m) { clearTimeout(timer); closeAll(m); setOpen(m, true); }
  function closeSoon() { clearTimeout(timer); timer = setTimeout(function () { closeAll(null); }, 180); }
  megas.forEach(function (m) {
    var trigger = m.querySelector('.wm-mega-trigger');
    trigger.addEventListener('click', function () {
      clearTimeout(timer);
      if (m.classList.contains('is-open')) { setOpen(m, false); } else { open(m); }
    });
    m.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'touch' && fine.matches && wide.matches) { open(m); } });
    m.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'touch' && fine.matches && wide.matches) { closeSoon(); } });
    m.addEventListener('focusout', function (e) { if (!m.contains(e.relatedTarget)) { closeSoon(); } });
    m.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setOpen(m, false); }); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') { return; }
    var o = megas.filter(function (m) { return m.classList.contains('is-open'); })[0];
    if (o) { setOpen(o, false); o.querySelector('.wm-mega-trigger').focus(); }
  });
  document.addEventListener('pointerdown', function (e) {
    if (!megas.some(function (m) { return m.contains(e.target); })) { closeAll(null); }
  });
  wide.addEventListener('change', function () { closeAll(null); });
})();
